import { calculateValue, getNumberValue, getValidatedValue } from "./number-input-utils";

describe("calculateValue", () => {
    it("should increment by given step", () => {
        expect(calculateValue("increment", 4, 2, NaN, NaN)).toEqual(6);
    });

    it("should decrement by given step", () => {
        expect(calculateValue("decrement", 6, 1, 20, 0)).toEqual(5);
    });

    it("should not exceed the max value", () => {
        expect(calculateValue("increment", 7, 1, 7, 0)).toEqual(7);
    });

    it("should not go under the min value", () => {
        expect(calculateValue("decrement", 0, 1, 20, 0)).toEqual(0);
    });
});

describe("getValidatedValue", () => {
    it("should handle strings", () => {
        expect(getValidatedValue("abc", 1, NaN, NaN)).toEqual(1);
    });

    it("should not exceed the max value", () => {
        expect(getValidatedValue(11, 1, 5, 0)).toEqual(5);
    });

    it("should not go under the min value", () => {
        expect(getValidatedValue(-12, 0, 10, -10)).toEqual(-10);
    });

    it("should round to nearest integer", () => {
        expect(getValidatedValue(1.1, 0, 10, -10)).toEqual(1);
    });
});

describe("getNumberValue", () => {
    it("0 should return a number", () => {
        expect(getNumberValue("0")).toEqual(0);
    });

    it("10 should return a number", () => {
        expect(getNumberValue("10")).toEqual(10);
    });

    it("should return NaN for empty strings", () => {
        expect(getNumberValue("")).toBeNaN();
    });
});
